<template>
    <button class="btn btn-primary" @click="triggerFileInput" :disabled="disabled">
        <i class="fas fa-paperclip"></i>
        Add file
        <input
            ref="fileInput"
            type="file"
            style="display: none"
            @change="handleFile"
        />
    </button>
</template>
  
<script>
    export default {
        name: 'FileUpload',
        props:  {
            disabled: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            triggerFileInput() {
                this.$refs.fileInput.click()
            },
            handleFile(e) {
                const file = e.target.files[0]
                this.$emit('upload', file)
            }
        }
    }
</script>

<style scoped>
    button.btn.btn-primary {
        width: 20rem;
        padding: 1rem 2rem;
        border-radius: 10px;
        font-size: 1.6rem;
    }
</style>
  